export const pipe =
  (init, ...rest) =>
  (...args) =>
    rest.reduce((acc, next) => next(acc), init(...args));
